import React, { useEffect, useRef, useState } from 'react';
import { cn } from 'utils/helpers';
import Button from 'components/v2/button/Button';
import UpdatesCard from '../UpdatesCard';
import { ReactComponent as CalidoLogo } from 'assets/images/common/add-contacts-card-logo.svg';

type Props = {
  className?: string;
  handleDismiss: (eventId: string, expiresAt?: Date) => void;
  isShadows?: boolean;
};

const SendMessageCard: React.FC<Props> = ({ isShadows = true, className }) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const [cardHeight, setCardHeight] = useState(0);

  useEffect(() => {
    if (cardRef.current) {
      setCardHeight(cardRef.current.clientHeight);
    }
  }, [cardRef.current]);

  return (
    <>
      {isShadows && (
        <div
          style={{ height: cardHeight }}
          className="absolute bg-transparent w-full shadow-[0px_50px_110px_-61px_#AAA8FF] rounded-[6rem] z-[-1]"
        ></div>
      )}
      <UpdatesCard
        isShadows={isShadows}
        cardRef={cardRef}
        title="Message Calido"
        description="SMS message with Calido to help you coordinate your plans with friends!"
        additionalDescription="Calido suggests times and places for you and your friends to hang and sends out invites for you!"
        emoji={<CalidoLogo className="w-[2.125rem] h-[2.125rem]" />}
        className={cn('shadow-none', className)}
        actionsChildren={
          <>
            <a
              href="sms:+14157797681"
              className="min-w-[65%] h-full w-full flex items-center justify-center"
            >
              <Button
                className={cn(
                  'w-full py-3 relative transition-all duration-500 flex items-center justify-center',
                )}
                variant="primary"
              >
                Click to message
              </Button>
            </a>
          </>
        }
      />
    </>
  );
};

export default SendMessageCard;
